import { Suspense, lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { PATHS } from "../../../../constants";
import { useAppDispatch } from "../../../../store";
import { setSearchText } from "../../store";
import SeedsTab from "../seeds-tab/seeds-tab";

const SeedEditingFormPage = lazy(() =>
  import("../seed-editing-form/seed-editing-form-page").then((module) => ({
    default: module.SeedEditingFormPage,
  }))
);

export const Seeds = (): JSX.Element => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSearchText(""));
  }, [dispatch]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path={PATHS.EDIT_PAGE + "/:id"} element={<SeedEditingFormPage />} />
        <Route path="*" element={<SeedsTab />} />
      </Routes>
    </Suspense>
  );
};
